import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
  api,
  clearAuthToken,
  getAuthToken,
  setAuthToken
} from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(getAuthToken());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const bootstrap = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const response = await api.get('/auth/me', token);
        setAdmin(response.admin);
      } catch (error) {
        clearAuthToken();
        setToken(null);
        setAdmin(null);
      } finally {
        setLoading(false);
      }
    };

    bootstrap();
  }, [token]);

  const value = useMemo(() => ({
    admin,
    token,
    loading,
    isAuthenticated: !!token && !!admin,
    login: async (email, password) => {
      const response = await api.post('/auth/login', { email, password });
      setAuthToken(response.token);
      setToken(response.token);
      setAdmin(response.admin);
      return response;
    },
    logout: () => {
      clearAuthToken();
      setToken(null);
      setAdmin(null);
    }
  }), [admin, token, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used inside AuthProvider');
  }
  return context;
}
